const player = {
  searchPlayers: 'Search Players',
  playerProfile: 'Player Profile',
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  signUpToSeeInfo: 'Sign Up to See Player Stats & Match History',
  loginToSeeInfo: `Login or create an account to see this user's win-loss record, average points won, average partner
  and opponent DUPRs, half-life, match history and more.`,
  profileUnlock: {
    title: 'Use unlock?',
    subtitle: 'Spend one of your free profile views',
    unlock: 'Unlock',
    limitReached: 'Limit reached',
    limitReachedSubtitle: 'Upgrade to DUPR+ for unlimited profile views',
    upgrade: 'Upgrade',
    upgradeLink: 'Upgrade for unlimited',
    viewsLeftShort_one: '{{count}} left',
    viewsLeftShort_other: '{{count}} left',
    infoTitle: 'Free profile views',
    info: 'You have {{count}} free profile views.',
    resets: 'Resets {{when}}.',
    banner: {
      viewsLeft_one: '{{count}} view left',
      viewsLeft_other: '{{count}} views left',
      runningLow: "You're running low",
      freeViewsLeft_one: '{{count}} free profile view left',
      freeViewsLeft_other: '{{count}} free profile views left',
      unlockUnlimited: 'Unlock Unlimited Profiles',
    },
  },
  filterRatingLocked: 'Upgrade to DUPR+ to filter by rating',
  ratingLocked: 'Rating locked',
}

export type LocalePlayer = typeof player

export default player
